import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class TabelaPrecoProvider {

  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into tabelapreco(Tab_Codigo, Tab_Nome, Tab_Tipo) values (?, ?, ?)';

          for (let val of data) {
            let tabela = new TabelaPreco();
            tabela.codigo = val.Tab_Codigo;
            tabela.nome = val.Tab_Nome;
            tabela.tipo = val.Tab_Tipo;
            tabela.itens = val.Itens;

            let params = [tabela.codigo, tabela.nome, tabela.tipo];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou tabela de preço');
            }, (err) => {
              console.log('erro:' + err);
            });

            for (let item of val.Itens) {
              let tbItem = new TabelaPrecoItem();
              tbItem.codigo_produto = item.Pro_Codigo;
              tbItem.preco = item.Tbi_Valor;
              let sql2 = 'insert into tabelapreco_itens(Tab_Codigo, Prod_Codigo, Tbi_Valor) values (?, ?, ?)';
              let params2 = [tabela.codigo, tbItem.codigo_produto, tbItem.preco];

              await tx.executeSql(sql2, params2, (tx, resultSet) => {
                console.log('importou tabela de preço - item');
              }, (err) => {
                console.log('erro:' + err);
              });

            }

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.executeSql('delete from tabelapreco_itens', []).catch((e) => console.error(e));
        db.executeSql('delete from tabelapreco', []).catch((e) => console.error(e));
      }).catch((e) => console.error(e));
  }

  public getAll(codCliente = 0) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT DISTINCT Tab_Codigo, Tab_Nome, Tab_Tipo FROM tabelapreco ';
        if (codCliente > 0) {
          sql += 'WHERE Tab_Codigo IN(SELECT Tab_Codigo FROM clientes_tabelapreco WHERE Cli_Codigo = ' + codCliente + ') ';
        } else {
          sql += 'WHERE COALESCE(Tab_Tipo, "P") = "P" ';
        }
        sql += 'order by COALESCE(Tab_Tipo, "P") DESC, Tab_Nome';

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let tabelas: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var tabela = new TabelaPreco();
                tabela.codigo = data.rows.item(i).Tab_Codigo;
                tabela.nome = data.rows.item(i).Tab_Nome;
                tabela.tipo = data.rows.item(i).Tab_Tipo;
                tabelas.push(tabela);
              }
              return tabelas;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

export class TabelaPreco {
  codigo: number;
  nome: string;
  tipo: string;
  itens: Array<{}>;
}

export class TabelaPrecoItem {
  codigo_produto: number;
  preco: number;
}



// WEBPACK FOOTER //
// ./src/providers/tabela-preco/tabela-preco.ts